import { BrowsingContextError } from '../../browsingContextError';

/**
 * Creates a new MutationObserver in the browsing context of the given node.
 */
export function createMutationObserver(
  context: Node | Document | Window,
  callback: MutationCallback,
): MutationObserver {
  const window = getWindowFromContext(context);
  if (!window) {
    throw new BrowsingContextError();
  }

  // Get the mutation observer for the element's window.
  const MutationObserver = (window as any).MutationObserver as {
    new (callback: MutationCallback): MutationObserver;
  };

  return new MutationObserver(callback);
}

function getWindowFromContext(context: Node | Document | Window): Window | null {
  if (isWindowContext(context)) {
    return context;
  }

  if (isDocumentContext(context)) {
    return context.defaultView;
  }

  if (isNodeContext(context)) {
    return context.ownerDocument && context.ownerDocument.defaultView;
  }

  return null;
}

function isWindowContext(context: Node | Document | Window): context is Window {
  return 'postMessage' in context;
}

function isDocumentContext(context: Node | Document | Window): context is Document {
  return 'defaultView' in context;
}

function isNodeContext(context: Node | Document | Window): context is Node {
  return 'ownerDocument' in context;
}
